module.exports = __webpack_public_path__ + "img/icon-5-percent.cf8f7388.svg";